var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"py-2 langButton",attrs:{"src":_vm.getImage,"contain":"","width":"15vw"},on:{"click":_vm.changeLang}})}
var staticRenderFns = []

export { render, staticRenderFns }